export const donationConstants = {
    // Add and editing donation
    SAVING_DONATION_REQUEST: 'SAVING_DONATION_REQUEST',
    SAVING_DONATION_SUCCESS: 'SAVING_DONATION_SUCCESS',
    SAVING_DONATION_FAILURE: 'SAVING_DONATION_FAILURE',

    // Loading donation
    LOAD_DONATION_REQUEST: 'LOAD_DONATION_REQUEST',
    LOAD_DONATION_SUCCESS: 'LOAD_DONATION_SUCCESS',
    LOAD_DONATION_FAILURE: 'LOAD_DONATION_FAILURE',

    // Delete donation
    DELETE_DONATION_REQUEST: 'DELETE_DONATION_REQUEST',
    DELETE_DONATION_SUCCESS: 'DELETE_DONATION_SUCCESS',
    DELETE_DONATION_FAILURE: 'DELETE_DONATION_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/donation.constants.js